import useTimeZone from 'hooks/useTimeZone';
import moment from 'moment-timezone';

export const formatDate = (date: Date | string | moment.Moment | undefined, timeZone: string): string => {
    if (!date) return '';

    return moment(date).tz(timeZone).format('MMM DD, YYYY - hh:mm a');
};
